import React from "react"

// Components
import SEO from "@components/SEO/SEO"

// Page Components
import ReferralHero from "./_components/ReferralHero/ReferralHero"
import FeatureGridBlock from "@components/lp/FeatureGridBlock/FeatureGridBlock"
import { ICON_TYPES } from "@helpscout/hs-marketing-shared-components"
import LpSection from "@components/lp/LpSection/LpSection"

export const Head = () => (
  <SEO
    description="Loving Help Scout and want to spread the word? Refer your friends and earn $250 for each person that signs up."
    image="/images/pages/referral/ReferralPage--meta.png"
    permalink="/referral/"
    robots="noindex,follow"
    title="Customer Referral Program - Help Scout"
  />
)

const ReferralPage = () => (
  <>
    <ReferralHero />
    <LpSection
      title="How Referrals Work"
      useMarginBottomL
    />
    <FeatureGridBlock
      gridItems={[
        {
          id: "step1",
          icon: ICON_TYPES["link"],
          text: "Enter your email, click create link, and generate your unique link so we know it’s you! Look out for an email from PartnerStack so we know how to pay you.",
          title: "Step 1: Create your link",
        },
        {
          id: "step2",
          icon: ICON_TYPES["announcement"],
          text: "Copy your link when you register above. Send it to as many people as you like in any way you want — they also get a $50 credit when they sign up.",
          title: "Step 2: Tell your friends",
        },
        {
          id: "step3",
          icon: ICON_TYPES["receive-money"],
          text: "Earn $300 for the first paying customer you refer. Earn $250 for each referral that becomes a paying customer thereafter and a bonus $50 for every 5.",
          title: "Step 3: Get paid",
        },
      ]}
    />
  </>
)

export default ReferralPage
